import { render, staticRenderFns } from "./IconStorageUserRole.vue?vue&type=template&id=57e30251&scoped=true"
import script from "./IconStorageUserRole.vue?vue&type=script&lang=js"
export * from "./IconStorageUserRole.vue?vue&type=script&lang=js"
import style0 from "./IconStorageUserRole.vue?vue&type=style&index=0&id=57e30251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e30251",
  null
  
)

export default component.exports